import React, { Component } from "react";
import GravityForm from "react-gravity-form";
import { Portal } from "react-portal";


export default class ProductEnquire extends Component {
	
	state = {
		isOpen: false,
	}
	handleToggle = () => {		
    	this.setState({ isOpen: !this.state.isOpen });
  	};
  	
  	componentDidMount() {
    	this.interval = setInterval(() => {
	    	if (document.getElementById('gravity_form_7')) {
		    	if (this.state.isOpen === true && document.getElementById('gravity_form_7').innerHTML.length < 3) {
			    	window.location = 'https://www.bloomingdales.com.au/thank-you';
			    	document.getElementById('gravity_form_7').innerHTML = '&nbsp;'
		    	}
	    	}
    	}, 100);
	}

	componentWillUnmount() {
	    clearInterval(this.interval);
	}


	render () {
		
		const product = this.props.title;
		const sku = this.props.sku;
		const butClass = this.props.butClass;
			
		return (
			<>
				<button className={butClass} onClick={this.handleToggle}>Enquire</button>
				<Portal>
					<div className={'c-enquire-modal ' + (this.state.isOpen ? 'state-open' : "")}>
						<div className="c-enquire-modal__overlay" onClick={this.handleToggle}></div>
						<div className="c-enquire-modal__panel">
							<div className="c-enquire-modal__panel__inner">
								<div className="c-enquire-modal__close" onClick={this.handleToggle}></div>
								<h3 className="c-enquire-modal__heading">Enquiry</h3>
								<div className="c-enquire-modal__form scope-form scope-form--enquire">
									<GravityForm
										backendUrl={document.location.origin + '/wp-json/bloomingdales/v1/form'}
										formID="7"
										populatedFields={{
											product: product,
											id: sku,
										}}
									/>
								</div>
							</div>
						</div>
					</div>
				</Portal>
			</>
		);
	}
}